import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Dexreactions = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Dexreactions - Buy All Dexscreener Reactions | Dexreaction</title>
        <meta name="description" content="Dexreactions - Your one-stop shop for all Dexscreener reactions! Buy rockets 🚀, fire 🔥, poop 💩, star ⭐ reactions from $0.05. Fastest delivery, 20% bonus. Telegram bot available!" />
        <meta name="keywords" content="dexreactions, buy dexscreener reactions, buy dexscreener rockets, buy dexscreener fire, buy dexscreener poop, dexscreener reaction service, all dexscreener reactions, cheap dexscreener reactions, dexreaction, dexmoji" />
        <link rel="canonical" href="https://dexreaction.com/dexreactions" />
        <meta property="og:title" content="Dexreactions - All Dexscreener Reactions | Dexreaction" />
        <meta property="og:description" content="Dexreactions - Buy all reaction types from $0.05! Rockets, fire, poop, star. Instant delivery!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dexreaction.com/dexreactions" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-purple-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Get Started
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-purple-500/20 text-purple-300 px-6 py-3 rounded-full font-semibold mb-6">
              ✨ All Dexscreener Reactions in One Place
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent">
                Dexreactions
              </span>
            </h1>
            <div className="flex justify-center gap-4 text-6xl mb-6">
              <span className="animate-bounce" style={{ animationDelay: '0ms' }}>🚀</span>
              <span className="animate-bounce" style={{ animationDelay: '100ms' }}>🔥</span>
              <span className="animate-bounce" style={{ animationDelay: '200ms' }}>💩</span>
              <span className="animate-bounce" style={{ animationDelay: '300ms' }}>🚩</span>
              <span className="animate-bounce" style={{ animationDelay: '400ms' }}>⭐</span>
            </div>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              Your One-Stop Shop for All DexScreener Reactions
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              Buy any reaction type at the best prices. Boost your token&apos;s visibility with rockets, fire, poop, flags, or stars. All starting at just $0.05!
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              Buy Dexreactions Now
            </button>
          </div>
        </section>

        {/* All Reactions */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              All Available Dexreactions
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              Choose the perfect reaction for your token
            </p>
            <div className="grid md:grid-cols-5 gap-6">
              {[
                { emoji: '🚀', name: 'Rocket', desc: 'Bullish momentum', color: 'from-orange-500 to-yellow-500', link: '/buy-dexscreener-rockets' },
                { emoji: '🔥', name: 'Fire', desc: 'Hot & trending', color: 'from-red-500 to-orange-500', link: '/buy-dexscreener-fire' },
                { emoji: '💩', name: 'Poop', desc: 'Meme culture', color: 'from-amber-600 to-yellow-600', link: '/buy-dexscreener-poop' },
                { emoji: '🚩', name: 'Red Flag', desc: 'Warning signal', color: 'from-red-600 to-pink-600', link: '/' },
                { emoji: '⭐', name: 'Favorite', desc: 'Community love', color: 'from-yellow-400 to-yellow-500', link: '/' }
              ].map((item, idx) => (
                <div key={idx} className={`bg-gradient-to-br ${item.color} p-1 rounded-xl cursor-pointer hover:scale-105 transition-all`} onClick={() => navigate(item.link)}>
                  <div className="bg-slate-900 rounded-lg p-6 text-center h-full">
                    <div className="text-5xl mb-3">{item.emoji}</div>
                    <h3 className="text-lg font-bold mb-2">{item.name}</h3>
                    <p className="text-sm text-gray-400 mb-3">{item.desc}</p>
                    <div className="text-purple-400 font-bold">$0.05</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Dexreactions */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Choose Dexreactions?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: '🎯', title: 'All Reactions', desc: 'Every DexScreener reaction type available. Rockets, fire, poop, flags, and stars.' },
                { icon: '💰', title: 'Best Prices', desc: 'Just $0.05 per reaction. Plus 20% bonus on every order!' },
                { icon: '⚡', title: 'Instant Delivery', desc: 'Reactions start delivering immediately after payment confirmation.' },
                { icon: '🔒', title: 'Safe & Secure', desc: 'Natural delivery patterns. Your token stays safe.' },
                { icon: '🤖', title: 'Multiple Options', desc: 'Order via web panel or Telegram bot - your choice!' },
                { icon: '24/7', title: 'Always Available', desc: 'Automated service running 24/7 with instant processing.' }
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-purple-500/20 rounded-xl p-6 hover:border-purple-500/50 transition-all">
                  <div className="text-4xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Simple Dexreactions Pricing
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              Same price for all reaction types + 20% bonus
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { qty: 500, price: 25, total: 600 },
                { qty: 1000, price: 50, total: 1200, popular: true },
                { qty: 1500, price: 75, total: 1800 },
                { qty: 2000, price: 100, total: 2400 }
              ].map((pkg) => (
                <div key={pkg.qty} className={`relative bg-gradient-to-br from-purple-900/30 to-pink-900/30 border-2 ${pkg.popular ? 'border-purple-500' : 'border-purple-500/30'} rounded-xl p-6 hover:border-purple-500 transition-all`}>
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-1 rounded-full text-sm font-bold">Most Popular</span>
                    </div>
                  )}
                  <div className="text-center">
                    <div className="flex justify-center gap-1 text-2xl mb-2">
                      <span>🚀</span><span>🔥</span><span>💩</span><span>⭐</span>
                    </div>
                    <div className="text-3xl font-bold mb-2">{pkg.qty}</div>
                    <div className="text-gray-400 mb-4">Any Reaction</div>
                    <div className="text-4xl font-bold text-purple-400 mb-2">${pkg.price}</div>
                    <div className="bg-green-500/20 rounded-lg p-2 mb-4">
                      <span className="text-green-400 font-semibold">Get {pkg.total} total</span>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              How Dexreactions Works
            </h2>
            <div className="space-y-6">
              {[
                { step: 1, title: 'Choose Reaction Type', desc: 'Select from rockets 🚀, fire 🔥, poop 💩, flags 🚩, or stars ⭐' },
                { step: 2, title: 'Select Quantity', desc: 'Pick your package or enter custom amount (500-10,000)' },
                { step: 3, title: 'Enter Token Link', desc: 'Provide your DexScreener token URL' },
                { step: 4, title: 'Pay & Receive', desc: 'Pay with SOL and watch your reactions roll in!' }
              ].map((item) => (
                <div key={item.step} className="flex gap-4 bg-slate-800/50 border border-purple-500/20 rounded-xl p-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-xl font-bold">
                    {item.step}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reaction Guide */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Quick Dexreactions Guide
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-purple-500/20">
                    <th className="px-6 py-4 text-left">Reaction</th>
                    <th className="px-6 py-4 text-left">Best For</th>
                    <th className="px-6 py-4 text-left">Signal</th>
                    <th className="px-6 py-4 text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { emoji: '🚀', name: 'Rocket', best: 'Launches, pumps', signal: 'Bullish', link: '/buy-dexscreener-rockets' },
                    { emoji: '🔥', name: 'Fire', best: 'Viral moments', signal: 'Hot', link: '/buy-dexscreener-fire' },
                    { emoji: '💩', name: 'Poop', best: 'Meme tokens', signal: 'Meme', link: '/buy-dexscreener-poop' },
                    { emoji: '🚩', name: 'Flag', best: 'Warnings', signal: 'Caution', link: '/' },
                    { emoji: '⭐', name: 'Star', best: 'Community', signal: 'Love', link: '/' }
                  ].map((item, idx) => (
                    <tr key={idx} className="border-b border-purple-500/10 hover:bg-purple-500/5">
                      <td className="px-6 py-4">
                        <span className="text-2xl mr-2">{item.emoji}</span>
                        <span className="font-semibold">{item.name}</span>
                      </td>
                      <td className="px-6 py-4 text-gray-400">{item.best}</td>
                      <td className="px-6 py-4">
                        <span className="bg-purple-500/20 text-purple-300 px-3 py-1 rounded-full text-sm">{item.signal}</span>
                      </td>
                      <td className="px-6 py-4">
                        <button onClick={() => navigate(item.link)} className="text-purple-400 hover:text-purple-300 font-semibold">
                          Buy →
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready for Dexreactions?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Start boosting your token with any reaction type today
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
              >
                Buy Dexreactions
              </button>
              <button
                onClick={() => window.open('https://t.me/dexreactionrobot', '_blank')}
                className="bg-slate-800 hover:bg-slate-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all border border-purple-500/30"
              >
                Try Telegram Bot
              </button>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-purple-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-purple-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-purple-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-purple-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Dexreactions;
